import { render, staticRenderFns } from "./WebsiteSetup.vue?vue&type=template&id=419f2cef&lang=pug"
import script from "./WebsiteSetup.vue?vue&type=script&lang=js"
export * from "./WebsiteSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports